/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Human_RequiredInputs */

const en_adm_err_human_required = /** @type {(inputs: Adm_Err_Human_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only people can do this, not agents.`)
};

const de_adm_err_human_required = /** @type {(inputs: Adm_Err_Human_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das geht nur für Personen, nicht für Agenten.`)
};

/**
* | output |
* | --- |
* | "Only people can do this, not agents." |
*
* @param {Adm_Err_Human_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_human_required = /** @type {((inputs?: Adm_Err_Human_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Human_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_human_required(inputs)
	return en_adm_err_human_required(inputs)
});